<div appAutoScroll [scrollRate]="0.5" [startDelay]="3000" [pauseTime]="4000">

<!-- Header -->
<header class="header" [class.scrolled]="headerScrolled">
  <div class="header-container">
    <div class="logo" (click)="scrollToSection('hero')">
      <img src="assets/Brokins_logo_RGB22.png" alt="Brokins" />
    </div>
    
    <nav class="desktop-nav">
      <a (click)="scrollToSection('hero')">Accueil</a>
      
      <!-- Dropdown Nos assurances -->
      <div class="nav-dropdown">
        <a class="dropdown-toggle">
          Nos assurances <i class="pi pi-chevron-down"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-categories">
          <!-- ...existing dropdown content... -->
          <!-- Category 1: Assurance des Personnes pour Particuliers -->
          <div class="dropdown-category">
            <div class="category-header">
              Assurance des Personnes pour Particuliers
              <i class="pi pi-chevron-right"></i>
            </div>
            <div class="category-submenu">
              <a [routerLink]="['/assurance-sante-particuliers']">Assurance Mutuelle Santé Individuelle</a>
              <a [routerLink]="['/assurance-mutuelle-sante-internationale']">Assurance Mutuelle Santé Internationale</a>
              <a [routerLink]="['/assurance-prevoyance-gav']">Assurance Prévoyance GAV</a>
              <a [routerLink]="['/assurance-prevoyance-ijh']">Assurance Prévoyance IJH</a>
              <a [routerLink]="['/assurance-prevoyance-obseque']">Assurance Prévoyance Obsèque</a>
              <a [routerLink]="['/assurance-prevoyance-deces']">Assurance Prévoyance Décès</a>
              <a [routerLink]="['/assurance-retraite-complementaire-salarie']">Assurance Retraite Complémentaire Salarié</a>
              <a [routerLink]="['/assurance-voyage-personnel']">Assurance Voyage Personnel</a>
              <a [routerLink]="['/assurance-credit-emprunteur']">Assurance Crédit — Assurance Emprunteur</a>
            </div>
          </div>

          <!-- Category 2: Assurance des Personnes pour Professionnels et Entreprises -->
          <div class="dropdown-category">
            <div class="category-header">
              Assurance des Personnes pour Professionnels et Entreprises
              <i class="pi pi-chevron-right"></i>
            </div>
            <div class="category-submenu">
              <a [routerLink]="['/assurance-sante-professionnels']">Assurance Mutuelle Santé Professionnelle</a>
              <a [routerLink]="['/assurance-mutuelle-sante-internationale-pro']">Assurance Mutuelle Santé Internationale Professionnelle</a>
              <a [routerLink]="['/assurance-collective-entreprise']">Assurance Mutuelle Santé Entreprise</a>
              <a [routerLink]="['/assurance-prevoyance-professionnelle']">Assurance Prévoyance Professionnelle</a>
              <a [routerLink]="['/assurance-prevoyance-entreprise']">Assurance Prévoyance Entreprise</a>
              <a [routerLink]="['/assurance-retraite-complementaire-pro']">Assurance Retraite Complémentaire Professionnelle</a>
              <a [routerLink]="['/assurance-retraite-complementaire-entreprise']">Assurance Retraite Complémentaire Entreprise</a>
              <a [routerLink]="['/assurance-voyage-professionnel']">Assurance Voyage Professionnel</a>
            </div>
          </div>

          <!-- Category 3: Assurance des Biens pour Particuliers -->
          <div class="dropdown-category">
            <div class="category-header">
              Assurance des Biens pour Particuliers
              <i class="pi pi-chevron-right"></i>
            </div>
            <div class="category-submenu">
              <a [routerLink]="['/assurance-multirisque-habitation']">Assurance Multirisque Habitation</a>
              <a [routerLink]="['/assurance-auto-particuliers']">Assurance Auto Personnelle</a>
              <a [routerLink]="['/assurance-moto-personnelle']">Assurance Moto Personnelle</a>
              <a [routerLink]="['/assurance-auto-temporaire']">Assurance Auto Temporaire</a>
              <a [routerLink]="['/assurance-multirisque-immeuble-pno']">Assurance Multirisque Immeuble - MAI - PNO</a>
              <a [routerLink]="['/assurance-loyers-impayes']">Assurance Loyers Impayés</a>
              <a [routerLink]="['/assurance-protection-juridique']">Assurance Protection Juridique</a>
              <a [routerLink]="['/assurance-oeuvres-art-bijoux']">Assurance Œuvres d'Art — Bijoux</a>
              <a [routerLink]="['/assurance-dommages-ouvrage']">Assurance Dommages Ouvrage</a>
              <a [routerLink]="['/assurance-animaux']">Assurance Chiens — Chats — Animaux</a>
              <a [routerLink]="['/assurance-velo-trottinette']">Assurance Vélo — Trottinette Electrique</a>
            </div>
          </div>

          <!-- Category 4: Assurance des Biens pour Professionnels et Entreprises -->
          <div class="dropdown-category">
            <div class="category-header">
              Assurance des Biens pour Professionnels et Entreprises
              <i class="pi pi-chevron-right"></i>
            </div>
            <div class="category-submenu">
              <a [routerLink]="['/assurance-auto-particuliers']">Assurance Auto Professionnelle</a>
              <a [routerLink]="['/assurance-moto-professionnelle']">Assurance Moto Professionnelle</a>
              <a [routerLink]="['/assurance-flotte-automobile']">Assurance Flotte Auto Professionnelle</a>
              <a [routerLink]="['/assurance-moto-professionnelle']">Assurance Flotte Moto Professionnelle</a>
              <a [routerLink]="['/assurance-multirisque-pro']">Assurance Multirisque Professionnelle</a>
              <a [routerLink]="['/assurance-multirisque-immeuble-pro']">Assurance Multirisque Immeuble — MAI — PNE</a>
              <a [routerLink]="['/assurance-bris-machine']">Assurance Bris de Machine</a>
              <a [routerLink]="['/assurance-cyber-risque']">Assurance Risque Cybersécurité Informatique — Cyberattaque</a>
              <a [routerLink]="['/assurance-locaux-professionnels']">Assurance Loueur de Véhicules</a>
              <a [routerLink]="['/assurance-marchandises-transportees']">Assurance Marchandises Transportées</a>
              <a [routerLink]="['/assurance-transport']">Assurance Transport</a>
            </div>
          </div>

          <!-- Category 5: Assurance de l'Activité des Professionnels et Entreprises -->
          <div class="dropdown-category">
            <div class="category-header">
              Assurance de l'Activité des Professionnels et Entreprises
              <i class="pi pi-chevron-right"></i>
            </div>
            <div class="category-submenu">
              <a [routerLink]="['/assurance-rc-entreprise']">Assurance Responsabilité Civile</a>
              <a [routerLink]="['/assurance-rc-mandataires-sociaux']">Assurance Responsabilité Civile Mandataires Sociaux</a>
              <a [routerLink]="['/assurance-rc-decennale']">Assurance Responsabilité Civile Décennale</a>
              <a [routerLink]="['/assurance-protection-juridique']">Assurance Protection Juridique Professionnelle</a>
              <a [routerLink]="['/assurance-perte-exploitation']">Assurance Perte d'Exploitation</a>
              <a [routerLink]="['/assurance-homme-cle']">Assurance Homme-Clé</a>
              <a [routerLink]="['/assurance-credit-professionnel']">Assurance Crédit Professionnel</a>
            </div>
          </div>

          <!-- Category 6: Autres Assurances -->
          <div class="dropdown-category">
            <div class="category-header highlight">
              Autres Assurances
              <i class="pi pi-chevron-right"></i>
            </div>
            <div class="category-submenu">
              <a [routerLink]="['/autres-assurances']" class="highlight-link">
                Voir toutes les assurances (45+)
              </a>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Dropdown Pourquoi Brokins -->
      <div class="nav-dropdown">
        <a class="dropdown-toggle">
          Pourquoi Brokins ? <i class="pi pi-chevron-down"></i>
        </a>
        <div class="dropdown-menu">
          <a [routerLink]="['/qui-sommes-nous']">Qui Sommes-Nous</a>
          <a [routerLink]="['/notre-equipe']">Notre Équipe</a>
          <a [routerLink]="['/notre-approche']">Notre Approche</a>
          <a [routerLink]="['/avantages-courtier-brokins']">Avantages courtier Brokins</a>
          <a (click)="scrollToSection('testimonials')">Avis Clients</a>
        </div>
      </div>
      
      <a [routerLink]="['/blog']">Blog</a>
      <a [routerLink]="['/recrutement']">Recrutement</a>
      <a [routerLink]="['/contact']">Contactez-nous</a>
    </nav>

    <div class="header-actions">
      <button class="btn-devis" (click)="navigateToComparison()">Devis</button>
      <button class="hamburger" (click)="toggleMobileMenu()">
        <i class="pi pi-bars"></i>
      </button>
    </div>
  </div>

  <div class="mobile-menu" [class.open]="mobileMenuOpen">
    <button class="close-btn" (click)="toggleMobileMenu()">
      <i class="pi pi-times"></i>
    </button>
    <nav>
      <a (click)="scrollToSection('hero'); toggleMobileMenu()">Accueil</a>
      
      <!-- Mobile Dropdown Nos assurances -->
      <div class="mobile-dropdown">
        <a class="mobile-dropdown-toggle" (click)="toggleMobileDropdown('assurances')">
          Nos assurances <i class="pi" [ngClass]="mobileDropdowns['assurances'] ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
        </a>
        <div class="mobile-dropdown-content" *ngIf="mobileDropdowns['assurances']">
          <!-- Catégorie 1: Personnes - Particuliers -->
          <div class="mobile-dropdown-section">
            <span class="mobile-section-title">Personnes - Particuliers</span>
            <a [routerLink]="['/assurance-sante-particuliers']" (click)="toggleMobileMenu()">Mutuelle Santé</a>
            <a [routerLink]="['/assurance-mutuelle-sante-internationale']" (click)="toggleMobileMenu()">Santé Internationale</a>
            <a [routerLink]="['/assurance-prevoyance-gav']" (click)="toggleMobileMenu()">Prévoyance GAV</a>
            <a [routerLink]="['/assurance-prevoyance-ijh']" (click)="toggleMobileMenu()">Prévoyance IJH</a>
            <a [routerLink]="['/assurance-prevoyance-obseque']" (click)="toggleMobileMenu()">Prévoyance Obsèque</a>
            <a [routerLink]="['/assurance-prevoyance-deces']" (click)="toggleMobileMenu()">Prévoyance Décès</a>
            <a [routerLink]="['/assurance-retraite-complementaire-salarie']" (click)="toggleMobileMenu()">Retraite Salarié</a>
            <a [routerLink]="['/assurance-voyage-personnel']" (click)="toggleMobileMenu()">Voyage Personnel</a>
            <a [routerLink]="['/assurance-credit-emprunteur']" (click)="toggleMobileMenu()">Crédit Emprunteur</a>
          </div>
          
          <!-- Catégorie 2: Personnes - Pro/Entreprises -->
          <div class="mobile-dropdown-section">
            <span class="mobile-section-title">Personnes - Pro/Entreprises</span>
            <a [routerLink]="['/assurance-sante-professionnels']" (click)="toggleMobileMenu()">Mutuelle Santé Pro</a>
            <a [routerLink]="['/assurance-mutuelle-sante-internationale-pro']" (click)="toggleMobileMenu()">Santé Internationale Pro</a>
            <a [routerLink]="['/assurance-collective-entreprise']" (click)="toggleMobileMenu()">Mutuelle Entreprise</a>
            <a [routerLink]="['/assurance-prevoyance-professionnelle']" (click)="toggleMobileMenu()">Prévoyance Pro</a>
            <a [routerLink]="['/assurance-prevoyance-entreprise']" (click)="toggleMobileMenu()">Prévoyance Entreprise</a>
            <a [routerLink]="['/assurance-retraite-complementaire-pro']" (click)="toggleMobileMenu()">Retraite Pro</a>
            <a [routerLink]="['/assurance-retraite-complementaire-entreprise']" (click)="toggleMobileMenu()">Retraite Entreprise</a>
            <a [routerLink]="['/assurance-voyage-professionnel']" (click)="toggleMobileMenu()">Voyage Pro</a>
          </div>
          
          <!-- Catégorie 3: Biens - Particuliers -->
          <div class="mobile-dropdown-section">
            <span class="mobile-section-title">Biens - Particuliers</span>
            <a [routerLink]="['/assurance-multirisque-habitation']" (click)="toggleMobileMenu()">Multirisque Habitation</a>
            <a [routerLink]="['/assurance-auto-particuliers']" (click)="toggleMobileMenu()">Auto Personnelle</a>
            <a [routerLink]="['/assurance-moto-personnelle']" (click)="toggleMobileMenu()">Moto Personnelle</a>
            <a [routerLink]="['/assurance-auto-temporaire']" (click)="toggleMobileMenu()">Auto Temporaire</a>
            <a [routerLink]="['/assurance-multirisque-immeuble-pno']" (click)="toggleMobileMenu()">MRI - PNO</a>
            <a [routerLink]="['/assurance-loyers-impayes']" (click)="toggleMobileMenu()">Loyers Impayés</a>
            <a [routerLink]="['/assurance-protection-juridique']" (click)="toggleMobileMenu()">Protection Juridique</a>
            <a [routerLink]="['/assurance-oeuvres-art-bijoux']" (click)="toggleMobileMenu()">Œuvres d'Art - Bijoux</a>
            <a [routerLink]="['/assurance-dommages-ouvrage']" (click)="toggleMobileMenu()">Dommages Ouvrage</a>
            <a [routerLink]="['/assurance-animaux']" (click)="toggleMobileMenu()">Animaux</a>
            <a [routerLink]="['/assurance-velo-trottinette']" (click)="toggleMobileMenu()">Vélo - Trottinette</a>
          </div>
          
          <!-- Catégorie 4: Biens - Pro/Entreprises -->
          <div class="mobile-dropdown-section">
            <span class="mobile-section-title">Biens - Pro/Entreprises</span>
            <a [routerLink]="['/assurance-auto-professionnelle']" (click)="toggleMobileMenu()">Auto Pro</a>
            <a [routerLink]="['/assurance-moto-professionnelle']" (click)="toggleMobileMenu()">Moto Pro</a>
            <a [routerLink]="['/assurance-flotte-auto-professionnelle']" (click)="toggleMobileMenu()">Flotte Auto</a>
            <a [routerLink]="['/assurance-flotte-moto-professionnelle']" (click)="toggleMobileMenu()">Flotte Moto</a>
            <a [routerLink]="['/assurance-biens-professionnels']" (click)="toggleMobileMenu()">Multirisque Pro</a>
            <a [routerLink]="['/assurance-multirisque-immeuble-pne']" (click)="toggleMobileMenu()">MRI - PNE</a>
            <a [routerLink]="['/assurance-bris-de-machine']" (click)="toggleMobileMenu()">Bris de Machine</a>
            <a [routerLink]="['/assurance-cyber-securite']" (click)="toggleMobileMenu()">Cybersécurité</a>
            <a [routerLink]="['/assurance-loueur-vehicules']" (click)="toggleMobileMenu()">Loueur Véhicules</a>
            <a [routerLink]="['/assurance-marchandises-transportees']" (click)="toggleMobileMenu()">Marchandises Transportées</a>
            <a [routerLink]="['/assurance-transport']" (click)="toggleMobileMenu()">Transport</a>
          </div>
          
          <!-- Catégorie 5: Activité - Pro/Entreprises -->
          <div class="mobile-dropdown-section">
            <span class="mobile-section-title">Activité - Pro/Entreprises</span>
            <a [routerLink]="['/assurance-rc-professionnelle']" (click)="toggleMobileMenu()">RC Professionnelle</a>
            <a [routerLink]="['/assurance-rc-mandataires-sociaux']" (click)="toggleMobileMenu()">RC Mandataires</a>
            <a [routerLink]="['/assurance-rc-decennale']" (click)="toggleMobileMenu()">RC Décennale</a>
            <a [routerLink]="['/assurance-protection-juridique-pro']" (click)="toggleMobileMenu()">Protection Juridique Pro</a>
            <a [routerLink]="['/assurance-perte-exploitation']" (click)="toggleMobileMenu()">Perte d'Exploitation</a>
            <a [routerLink]="['/assurance-homme-cle']" (click)="toggleMobileMenu()">Homme-Clé</a>
            <a [routerLink]="['/assurance-credit-professionnel']" (click)="toggleMobileMenu()">Crédit Pro</a>
          </div>
          
          <!-- Catégorie 6: Autres -->
          <div class="mobile-dropdown-section">
            <span class="mobile-section-title">Autres Assurances</span>
            <a [routerLink]="['/autres-assurances']" (click)="toggleMobileMenu()">Voir toutes nos assurances</a>
          </div>
        </div>
      </div>
      
      <!-- Mobile Dropdown Pourquoi Brokins -->
      <div class="mobile-dropdown">
        <a class="mobile-dropdown-toggle" (click)="toggleMobileDropdown('brokins')">
          Pourquoi Brokins <i class="pi" [ngClass]="mobileDropdowns['brokins'] ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
        </a>
        <div class="mobile-dropdown-content" *ngIf="mobileDropdowns['brokins']">
          <a [routerLink]="['/qui-sommes-nous']" (click)="toggleMobileMenu()">Qui Sommes-Nous</a>
          <a [routerLink]="['/notre-equipe']" (click)="toggleMobileMenu()">Notre Équipe</a>
          <a [routerLink]="['/notre-approche']" (click)="toggleMobileMenu()">Notre Approche</a>
          <a [routerLink]="['/avantages-courtier-brokins']" (click)="toggleMobileMenu()">Avantages courtier Brokins</a>
          <a (click)="scrollToSection('testimonials'); toggleMobileMenu()">Avis Clients</a>
        </div>
      </div>
      
      <a [routerLink]="['/blog']" (click)="toggleMobileMenu()">Blog</a>
      <a [routerLink]="['/recrutement']" (click)="toggleMobileMenu()">Recrutement</a>
      <a [routerLink]="['/contact']" (click)="toggleMobileMenu()">Contact</a>
      <button class="btn-devis-mobile" (click)="navigateToComparison()">Obtenir un devis</button>
    </nav>
  </div>
</header>

<!-- Hero Section -->
<section id="hero" class="hero-section">
  <video 
    autoplay 
    muted 
    loop 
    playsinline
    preload="auto"
    class="hero-video"
    [muted]="true"
    [autoplay]="true">
    <source src="assets/videos/hero-video.mp4" type="video/mp4">
    Votre navigateur ne supporte pas la lecture de vidéos.
  </video>
  <div class="hero-overlay"></div>

  <div class="hero-content" @fadeIn>
    <!-- ✅ Titre avec ligne violette -->
    <div class="hero-title-wrapper">
      <div class="hero-line"></div>
      <h1>Courtier de toutes vos assurances</h1>
    </div>

    <!-- ✅ Bloc de texte avec mots en violet -->
    <div class="hero-text-block">
      <p class="hero-paragraph">
        Le courtier en assurances Brokins trouve les meilleurs contrats d'assurance pour ses clients répartis partout en France. Qu'il s'agisse de contrats d'assurance pour les <span class="highlight-violet">Professionnels</span>, les <span class="highlight-violet">Entreprises</span>, ou les <span class="highlight-violet">Particuliers</span>, notre équipe d'experts vous conseille gratuitement 6j/7.
      </p>
      <p class="hero-paragraph">
        Faites confiance à un courtier qui travaille pour ses clients en leur apportant avant tout des réponses à leurs problématiques : <span class="highlight-violet">Mutuelle Santé</span>, <span class="highlight-violet">Flotte Auto</span>, <span class="highlight-violet">Assurance de crédit Immobilier</span>, <span class="highlight-violet">Assurance Habitation</span>, <span class="highlight-violet">RC PRO</span>, <span class="highlight-violet">Assurance Transport</span>, <span class="highlight-violet">Loueur de véhicules</span>, etc, nos devis sont 100% gratuits.
      </p>
    </div>
  </div>

  <div class="scroll-indicator" (click)="scrollToSection('guarantee')">
    <i class="pi pi-chevron-down"></i>
  </div>
</section>

<!-- Guarantee Section -->
<section id="guarantee" class="guarantee-section">
  <div class="container">
    <div class="guarantee-content">
      <h2>Assurez-vous correctement</h2>
      <p class="subtitle">
        Améliorez vos garanties, réduisez vos coûts et soyez suivis par un conseiller de notre<br>
        <strong class="highlight">Cabinet de Courtage</strong> comme tous nos clients partout en France.
      </p>
    </div>
  </div>
</section>

<!-- Testimonials Section -->
<section id="testimonials" class="testimonials-section">
  <div class="container">
    <h2>Avis Clients</h2>
    <p class="section-intro">Ils nous font confiance</p>
    
    <!-- ✅ Loading State -->
    <div class="reviews-loading" *ngIf="reviewsLoading">
      <i class="pi pi-spin pi-spinner"></i>
      <p>Chargement des avis...</p>
    </div>

    <!-- ✅ Error State -->
    <div class="reviews-error" *ngIf="reviewsError">
      <i class="pi pi-exclamation-triangle"></i>
      <p>{{ reviewsError }}</p>
    </div>

    <!-- ✅ Google Reviews Layout with Rating on Left -->
    <div class="reviews-main-container" *ngIf="!reviewsLoading && !reviewsError">
      <!-- Rating Summary - Left Side -->
      <div class="reviews-rating-side">
        <div class="rating-summary">
          <div class="rating-value">{{ averageRating.toFixed(1) }}</div>
          <div class="rating-stars">
            <i class="pi pi-star-fill" *ngFor="let star of getStarArray(Math.round(averageRating))"></i>
          </div>
          <div class="rating-count">Basé sur {{ totalRatings }} avis</div>
          <img src="https://www.gstatic.com/images/branding/googlelogo/svg/googlelogo_clr_74x24px.svg" alt="Google" class="google-logo">
        </div>
      </div>

      <!-- Reviews Carousel - Right Side (3 reviews at once) -->
      <div class="reviews-carousel-container">
        <button class="carousel-btn carousel-btn-prev" (click)="previousReviewGroup()" [disabled]="currentReviewIndex === 0">
          <i class="pi pi-chevron-left"></i>
        </button>
        
        <div class="reviews-carousel">
          <div class="reviews-track" [style.transform]="'translateX(-' + (currentReviewIndex * 100) + '%)'">
            <div class="review-group" *ngFor="let group of reviewGroups; let i = index">
              <div class="review-card" *ngFor="let review of group" @fadeIn>
                <!-- Wavy background decoration -->
                <svg class="wave-decoration" viewBox="0 0 400 100" preserveAspectRatio="none">
                  <path d="M0,50 Q100,20 200,50 T400,50" fill="none" stroke="rgba(147, 51, 234, 0.1)" stroke-width="2"/>
                  <path d="M0,60 Q100,30 200,60 T400,60" fill="none" stroke="rgba(147, 51, 234, 0.08)" stroke-width="2"/>
                  <path d="M0,70 Q100,40 200,70 T400,70" fill="none" stroke="rgba(147, 51, 234, 0.05)" stroke-width="2"/>
                </svg>
                
                <div class="review-header">
                  <!-- Use initials avatar instead of loading photos -->
                  <div class="reviewer-avatar">
                    {{ review.author_initials }}
                  </div>
                  <div class="reviewer-info">
                    <div class="reviewer-name">{{ review.author_name }}</div>
                    <div class="review-stars">
                      <i 
                        *ngFor="let star of getStarArray(review.rating)" 
                        class="pi pi-star-fill">
                      </i>
                    </div>
                    <div class="review-time">{{ review.relative_time_description }}</div>
                  </div>
                </div>
                <div class="review-text">
                  {{ review.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <button class="carousel-btn carousel-btn-next" (click)="nextReviewGroup()" [disabled]="currentReviewIndex >= reviewGroups.length - 1">
          <i class="pi pi-chevron-right"></i>
        </button>
        
        <!-- Carousel dots -->
        <div class="carousel-dots">
          <button 
            *ngFor="let group of reviewGroups; let i = index" 
            class="carousel-dot" 
            [class.active]="i === currentReviewIndex"
            (click)="goToReviewGroup(i)">
          </button>
        </div>
      </div>
    </div>

    <!-- ✅ Lien vers Google Reviews -->
    <a 
      href="https://www.google.com/search?q=brokins+paris#lrd=0x47e66e376ab5b5d1:0x7576443fd018ced1,1"
      target="_blank"
      rel="noopener noreferrer"
      class="view-all-reviews">
      Voir plus de commentaires clients sur Google
      <i class="pi pi-external-link"></i>
    </a>
  </div>
</section>

<!-- Services Section -->
<section id="services" class="services-section">
  <div class="container">
    <h2>Les contrats d'assurance proposés par Brokins</h2>
    <p class="section-intro">
      Que vous soyez un particulier, un professionnel, une entreprise, faites vous aider aujourd'hui!
    </p>
    
    <div class="services-grid">
      <div class="service-card" *ngFor="let service of services" @slideIn>
        <!-- ✅ Icône à gauche -->
        <div class="service-icon">
          <i [class]="service.icon"></i>
        </div>
        
        <!-- ✅ Contenu texte à droite -->
        <div class="service-content">
          <h3>{{ service.title }}</h3>
          <p>{{ service.description }}</p>
          <a [routerLink]="service.link" class="service-link">
            En savoir plus <i class="pi pi-arrow-right"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Partners Section -->
<section id="partners" class="partners-section">
  <div class="container">
    <h2>Nos Partenaires</h2>
    <p class="section-intro">Ils nous font confiance</p>
    
    <!-- ✅ Carousel infini -->
    <div class="slider">
      <div class="slide-track">
        <!-- ✅ Première série de logos -->
        <div class="slide" *ngFor="let partner of partners">
          <img 
            [src]="'assets/images/logos/' + partner + '-logo.png'" 
            [alt]="partner"
            class="partner-logo">
        </div>
        <!-- ✅ Duplication pour l'effet infini -->
        <div class="slide" *ngFor="let partner of partners">
          <img 
            [src]="'assets/images/logos/' + partner + '-logo.png'" 
            [alt]="partner"
            class="partner-logo">
        </div>
      </div>
    </div>

    <!-- Stats Grid -->
    <div class="stats-grid">
      <div class="stat-item" *ngFor="let stat of stats" @fadeIn>
        <div class="stat-value">{{ stat.value }}</div>
        <div class="stat-label">{{ stat.label }}</div>
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section class="cta-section">
  <div class="container">
    <h2>Commencez dès maintenant avec des devis gratuits.</h2>
    <div class="cta-features">
      <div class="cta-feature">
        <i class="pi pi-check-circle"></i>
        <span>Sans engagement</span>
      </div>
      <div class="cta-feature">
        <i class="pi pi-check-circle"></i>
        <span>Plusieurs offres proposées</span>
      </div>
      <div class="cta-feature">
        <i class="pi pi-check-circle"></i>
        <span>Conseils gratuits</span>
      </div>
    </div>
    <button class="btn-primary-large" (click)="navigateToComparison()">Devis</button>
  </div>
</section>

<!-- Contact Section -->
<section id="contact" class="contact-section">
  <div class="container">
    <div class="contact-grid">
      <div class="contact-info">
        <h2>Contactez-nous</h2>
        
        <div class="info-block">
          <h3>Cabinet Brokins</h3>
          <p>
            <i class="pi pi-map-marker"></i>
            79 rue de Rennes<br>
            75006 Paris<br>
            FRANCE
          </p>
        </div>

                <div class="info-block">
          <h3>Nos assurances</h3>
          <ul>
            <li><a [routerLink]="['/assurance-credit-emprunteur']">Assurance de prêt</a></li>
            <li><a [routerLink]="['/assurance-sante-particuliers']">Assurance Mutuelle Santé des particuliers</a></li>
            <li><a [routerLink]="['/assurance-sante-professionnels']">Assurance Mutuelle Santé des professionnels</a></li>
            <li><a [routerLink]="['/assurance-collective-entreprise']">Assurance Mutuelle Santé des Entreprises</a></li>
            <li><a [routerLink]="['/assurance-flotte-automobile']">Assurance Flotte Auto Entreprise</a></li>
            <li><a [routerLink]="['/assurance-prevoyance-particuliers']">Assurance Prévoyance</a></li>
            <li><a [routerLink]="['/assurance-retraite-complementaire-salarie']">Assurance Retraite (PER)</a></li>
          </ul>
        </div>
        <div class="info-block">
          <h3>Pourquoi Brokins</h3>
          <ul>
            <li><a [routerLink]="['/qui-sommes-nous']">Qui Sommes-Nous</a></li>
            <li><a [routerLink]="['/notre-equipe']">Notre Équipe</a></li>
            <li><a (click)="scrollToSection('testimonials')">Avis et Commentaires Clients</a></li>
            <li><a (click)="scrollToSection('services')">Nos Assurances</a></li>
            <li><a (click)="scrollToSection('contact')">Contact</a></li>
          </ul>
        </div>

        <div class="info-block">
          <h3>Courtier en Assurances</h3>
          <ul>
            <li><a [routerLink]="['/mentions-legales']">Mentions légales</a></li>
            <li><a [routerLink]="['/cgv']">Conditions de vente</a></li>
            <li><a [routerLink]="['/politique-confidentialite']">Politique de confidentialité</a></li>
          </ul>
        </div>
      </div>

      <div class="contact-form-container">
        <h3>Demandez un devis gratuit</h3>
        
        <div *ngIf="formSuccess" class="success-message" @fadeIn>
          <i class="pi pi-check-circle"></i>
          Merci, nous vous contacterons sous peu!
        </div>

        <form (ngSubmit)="submitContactForm()" *ngIf="!formSuccess">
          <div class="form-row">
            <div class="form-group">
              <input 
                type="text" 
                [(ngModel)]="contactForm.prenom" 
                name="prenom"
                placeholder="Prénom *"
                [class.error]="formSubmitted && !contactForm.prenom">
            </div>
            <div class="form-group">
              <input 
                type="text" 
                [(ngModel)]="contactForm.nom" 
                name="nom"
                placeholder="Nom *"
                [class.error]="formSubmitted && !contactForm.nom">
            </div>
          </div>

          <div class="form-group">
            <input 
              type="email" 
              [(ngModel)]="contactForm.email" 
              name="email"
              placeholder="E-mail *"
              [class.error]="formSubmitted && !contactForm.email">
          </div>

          <div class="form-group">
            <input 
              type="tel" 
              [(ngModel)]="contactForm.telephone" 
              name="telephone"
              placeholder="Téléphone *"
              [class.error]="formSubmitted && !contactForm.telephone">
          </div>

          <div class="form-group">
            <select [(ngModel)]="contactForm.sujet" name="sujet">
              <option value="">Sujet</option>
              <option value="particulier">Assurance Particulier</option>
              <option value="professionnel">Assurance Professionnel</option>
              <option value="entreprise">Assurance Entreprise</option>
            </select>
          </div>

          <div class="form-group">
            <textarea 
              [(ngModel)]="contactForm.message" 
              name="message"
              placeholder="Message"
              rows="5">
            </textarea>
          </div>

          <button type="submit" class="btn-submit">Envoyer</button>
        </form>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="footer">
  <div class="container">
    <div class="footer-content">
      <div class="footer-column">
        <img src="assets/logo.png" alt="Brokins" class="footer-logo">
        <p class="footer-tagline">
          Votre courtier en assurances de confiance depuis 2016
        </p>
        <div class="social-icons">
          <a href="#" aria-label="LinkedIn"><i class="pi pi-linkedin"></i></a>
          <a href="#" aria-label="Facebook"><i class="pi pi-facebook"></i></a>
          <a href="#" aria-label="Twitter"><i class="pi pi-twitter"></i></a>
          <a href="#" aria-label="Instagram"><i class="pi pi-instagram"></i></a>
        </div>
      </div>

      <div class="footer-column">
        <h4>Navigation</h4>
        <ul>
          <li><a (click)="scrollToSection('hero')">Accueil</a></li>
          <li><a (click)="scrollToSection('services')">Nos assurances</a></li>
          <li><a [routerLink]="['/qui-sommes-nous']">Notre approche</a></li>
          <li><a (click)="scrollToSection('testimonials')">Avis clients</a></li>
          <li><a [routerLink]="['/contact']">Contact</a></li>
        </ul>
      </div>

      <div class="footer-column">
        <h4>Mentions Légales</h4>
        <ul>
          <li><a [routerLink]="['/mentions-legales']">Mentions légales</a></li>
          <li><a [routerLink]="['/cgv']">Conditions de vente</a></li>
          <li><a [routerLink]="['/politique-confidentialite']">Politique de cookies</a></li>
          <li><a [routerLink]="['/politique-confidentialite']">Politique de confidentialité</a></li>
          <li><a [routerLink]="['/politique-confidentialite']">RGPD</a></li>
        </ul>
      </div>

      <div class="footer-column">
        <h4>Contact</h4>
        <ul class="contact-list">
          <li>
            <i class="pi pi-phone"></i>
            <a href="tel:0143271243">01 43 27 12 43</a>
          </li>
          <li>
            <i class="pi pi-envelope"></i>
            <a href="mailto:contact@brokins.fr">contact&#64;brokins.fr</a>
          </li>
          <li>
            <i class="pi pi-map-marker"></i>
            79 rue de Rennes, 75006 Paris
          </li>
        </ul>
      </div>
    </div>

    <div class="footer-bottom">
      <p>&copy; 2025 Brokins SAS – Tous droits réservés</p>
      <button class="scroll-to-top" (click)="scrollToTop()" *ngIf="headerScrolled">
        <i class="pi pi-arrow-up"></i>
      </button>
    </div>
  </div>
</footer>
</div>